import { Patterns } from "@omni/schemas/input/patterns";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { Translate } from "@omni/types/utils/translate";
import { addMethod, number as yupNumber, string as yupString } from "yup";

import { Config } from "@/utils/config.utils";

import { BONUSCARD_DISCOUNT_PREFIX } from "../config";
import { string } from "./general.RHF";

addMethod(yupNumber, "valutaBetweenRHF", function (min, max) {
    return this.test("valutaBetweenRHF", function (value) {
        return (
            // @ts-expect-error
            (value >= min && value <= max) ||
            this.createError({
                message: () => () => (t: Translate) =>
                    t("form.validation.input.valuta.between", min, max)
            })
        );
    });
});

addMethod(yupString, "giftCardRHF", function () {
    return this.test("giftCardRHF", { exclusive: true }, function (value) {
        if (Patterns[Config.general.basestore].giftCard.test(value || "")) {
            return true;
        }
        return this.createError({
            message: () => () => (t: Translate) =>
                t("general.form.input.validation.giftCard.invalidformat")
        });
    });
});

addMethod(
    yupString,
    "verifyBonusCardPresence",
    function (customer: ComponentsCustomer | null) {
        return this.test("verifyBonusCardPresence", function (value = "") {
            const matchesPrefix = value?.startsWith(BONUSCARD_DISCOUNT_PREFIX);
            if (matchesPrefix && !customer?.bonusCardNumber) {
                return this.createError({
                    message: () => () => (t: Translate) =>
                        t(
                            "general.form.input.validation.verifyBonusCardPresence"
                        )
                });
            }
            return true;
        });
    }
);

export const giftCard = string()
    .nullable()
    .required(
        () => () => (t: Translate) =>
            t("checkout.paymentMethods.giftCard.validation.input.required")
    )
    .min(10)
    .max(20)
    .giftCardRHF();

export const giftCardCheckout = (customer?: ComponentsCustomer | null) =>
    giftCard.verifyBonusCardPresence(customer);

export const giftCardQuantity = yupNumber()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .nullable()
    .required()
    .integer()
    .min(1)
    .max(999);

export const giftCardAmountInEuros = yupNumber()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .nullable()
    .required()
    .integer()
    .valutaBetweenRHF(5, 2500);

export const giftCardSku = string().nullable().required();

export const contact = string().nullable().required().max(100);
